import { Claim } from '@wsphere/warranties/domain';

/** Every job is resolved or rejected, so the claim can be closed. */
export function hasOnlyFinishedJobs(claim: Pick<Claim.Model, 'items'> | null | undefined) {
  const items = claim?.items ?? [];
  return (
    !!items.length &&
    !items.some(item => item.status === Claim.ClaimItem.Status.DRAFT || item.status === Claim.ClaimItem.Status.APPROVED)
  );
}
